/**
 * Auth Module - Simplified Supabase Auth
 *
 * SIMPLIFIED: Using Supabase Auth directly instead of abstraction layer
 * to avoid circular dependency issues. Future: can add abstraction when needed.
 */

// Re-export supabase client for auth operations
// This avoids circular dependency by not creating an adapter
export { supabase as authClient } from '../supabase';

// For backward compatibility, also export as authProvider
export { supabase as authProvider } from '../supabase';

// Helper to determine user scenario
export type UserScenario = 'consumer' | 'prosumer' | 'enterprise' | null;

export function getUserScenario(email: string | undefined, metadata?: any): UserScenario {
  if (!email) return null;

  const enterpriseDomains = ['alerislife.com', 'enterprise.com', 'corp.com'];
  const domain = email.split('@')[1];

  if (enterpriseDomains.includes(domain) || metadata?.sso_provider) {
    return 'enterprise';
  }

  const prosumerDomains = ['gmail.com', 'github.com', 'outlook.com'];
  if (prosumerDomains.includes(domain) || metadata?.provider !== 'email') {
    return 'prosumer';
  }

  return 'consumer';
}

// Auth error handling helper
export function handleAuthError(error: any): string {
  if (error?.message) {
    if (error.message.includes('Invalid login') || error.message.includes('Invalid credentials')) {
      return 'Invalid email or password. Please try again.';
    }
    if (error.message.includes('Email not confirmed')) {
      return 'Please check your email to confirm your account.';
    }
    if (error.message.includes('User already registered')) {
      return 'An account with this email already exists.';
    }
    return error.message;
  }
  return 'An unexpected error occurred. Please try again.';
}

// Re-export types
export type { IAuthProvider, OIDCUser, OAuth2Session, OAuth2Provider, AuthEvent } from './IAuthProvider';
